<p id="modalContent" *transloco="let t; read: 'qqc'">
  {{
    t('age-ambiguity.content', { maxDependentAge: maxDependentAge$ | async })
  }}
</p>
<ng-container *ngFor="let radio of radios$ | async as list">
  <nibtravel-radio-group
    [radioGroup]="radio.config"
    (checked)="onCheck($event, radio.id)"
  ></nibtravel-radio-group>
</ng-container>
